import { arrayOf, func, node, object, objectOf, oneOf, shape, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { getHandler } from 'ravenjs/utils/actions';
import Button from 'ravenjs/lib/Button';
import Typography from 'ravenjs/lib/Typography';

import DropdownActions from './DropdownActions';

const ActionButtonsStyled = styled.div`
    margin-bottom: 1rem;
    ${({ theme }) => theme.media.up('md')`
        display: flex;
        justify-content: flex-end;
    `};
    ${({ theme }) => theme.media.down('md')`
        display: block;
    `};
`;

const ButtonWrapper = styled.div`
    position: relative;
    ${({ theme }) => theme.media.up('md')`
        margin-right: 24px;
    `};
    ${({ theme }) => theme.media.down('md')`
        margin-top: 1rem;
        margin-right: 0;
    `};
    &:last-of-type {
        margin-right: 0;
    }
`;

const ActionButtons = props => {
    const { actions, buttons } = props;

    const renderButton = ({ btnProps, id, label, onClickRef, type, Icon, options }) => {
        const handleActionClick = getHandler(actions, onClickRef);

        if (type === 'single') {
            return (
                <ButtonWrapper key={id}>
                    <Button {...btnProps} onClick={handleActionClick}>
                        {Icon && (
                            <Icon
                                fill="currentColor"
                                style={{ marginRight: '0.625rem', verticalAlign: '-3px' }}
                            />
                        )}
                        <Typography type="tableActionButtons">{label}</Typography>
                    </Button>
                </ButtonWrapper>
            );
        } else if (type === 'dropdown') {
            return (
                <ButtonWrapper key={id}>
                    <DropdownActions label={label} items={options} handlers={actions} />
                </ButtonWrapper>
            );
        }
        return null;
    };

    return <ActionButtonsStyled>{buttons.map(button => renderButton(button))}</ActionButtonsStyled>;
};

ActionButtons.propTypes = {
    actions: objectOf(func),
    buttons: arrayOf(
        shape({
            icon: string,
            id: string.isRequired,
            btnProps: object,
            label: string,
            onClick: string,
            options: arrayOf(
                shape({
                    Icon: node,
                    id: string.isRequired,
                    btnProps: object,
                    label: string,
                    onClick: string,
                })
            ),
            type: oneOf(['single', 'dropdown']),
        })
    ),
};

ActionButtons.defaultProps = {
    actions: {},
    buttons: [],
};

export default ActionButtons;
